import { createContext } from 'react';
import { PageContextProps, PageKeys } from '../App.types';
import { IAppointment } from '../components/appointment/appointment';

export const PageContext = createContext<PageContextProps>({
    setPage: () => {},
    setAlert: () => {},
    page: PageKeys.appointment,
    id: 0,
    setId: () => {},
    setData: () => {},
    data: {} as IAppointment,
    isModal: false,
    setIsModal: () => {},
    successMessage: '',
    setSuccessMessage: () => {},
    errorMessage: '',
    setErrorMessage: () => {},
});
